"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class LikeModule {
    constructor(wpApiSettings, likeStorage, sharedPosts, likedPostsStructurer, likedPostsApiUrlBuilder, postTypesToShow, postAppearance, renderContainer, noPostsNotice, preLoaders) {
        this.wpApiSettings = wpApiSettings;
        this.likeStorage = likeStorage;
        this.sharedPosts = sharedPosts;
        this.likedPostsStructurer = likedPostsStructurer;
        this.likedPostsApiUrlBuilder = likedPostsApiUrlBuilder;
        this.postTypesToShow = postTypesToShow;
        this.postAppearance = postAppearance;
        this.renderContainer = renderContainer;
        this.noPostsNotice = noPostsNotice;
        this.preLoaders = preLoaders;
        this.displayNoneClass = 'u-display--none';
        this.likedPosts = this.likeStorage.get();
        if (this.sharedPosts) {
            const decodedSharedPosts = atob(this.sharedPosts);
            const apiUrl = JSON.parse(decodedSharedPosts);
            if (typeof apiUrl === 'string' && apiUrl.length > 0) {
                this.fetchPosts(apiUrl);
            }
            else {
                console.error('Invalid shared posts data:', this.sharedPosts);
                this.noPostsFound();
            }
        }
        else {
            this.handleLikedPosts();
        }
    }
    handleLikedPosts() {
        if (Object.keys(this.likedPosts).length <= 0) {
            this.noPostsFound();
            return;
        }
        const apiUrl = this.likedPostsApiUrlBuilder.build(this.likedPosts, this.postAppearance, this.postTypesToShow);
        this.fetchPosts(apiUrl);
    }
    fetchPosts(apiUrl) {
        var _a, _b;
        fetch(apiUrl, {
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-NONCE': (_b = (_a = this.wpApiSettings) === null || _a === void 0 ? void 0 : _a.nonce) !== null && _b !== void 0 ? _b : '',
            }
        })
            .then(response => {
            if (!response.ok) {
                throw new Error('Failed to fetch post');
            }
            return response.json();
        })
            .then(postsMarkup => {
            this.handleFetched(postsMarkup);
        })
            .catch(error => {
            console.error('Fetch error:', error);
            this.noPostsFound();
        });
    }
    handleFetched(posts) {
        if (!posts || typeof posts !== 'string') {
            this.noPostsFound();
            return;
        }
        this.removePreloaders();
        this.renderContainer.innerHTML = posts;
    }
    removePreloaders() {
        this.preLoaders.forEach((preloader) => {
            preloader.remove();
        });
    }
    noPostsFound() {
        this.noPostsNotice.classList.remove(this.displayNoneClass);
        this.removePreloaders();
    }
}
exports.default = LikeModule;
